import { Grid, Typography } from '@mui/material';
import React from 'react';
import { useIntl } from 'react-intl';
import { useTheme } from '@emotion/react';

const Chart = () => {
	const { $t } = useIntl();
	const theme = useTheme();

	return (
		<Grid
			bgcolor={'rgba(255, 251, 242, 1)'}
			py={{ xs: '18px', xxs: '27px', md: '75px', lg: '103px' }}
			px={'10%'}
			position="relative"
			zIndex={2}
		>
			<Grid className="card">
				<Typography
					pb={'16px'}
					variant={'h2'}
					fontWeight={900}
					color={theme.palette.secondary.one}
					padding={'20px'}
				>
					{$t({ id: 'chartTitle' })}
				</Typography>
				<Grid
					container
					className="content"
					display={'flex'}
					direction={{ md: 'row', xs: 'column' }}
					justifyContent={{ md: 'space-around' }}
					alignItems={'center'}
				>
					<img
						src="/assets/Images/Chart.jpg"
						width={'100%'}
						height={'100%'}
						alt="chart"
						style={{
							objectFit: 'contain',
						}}
					/>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default Chart;
